export const DEFAULT_COUNTDOWN_TIME_LENGTH = 120;

export enum CounterCodes {
  CheckoutAuth = 'checkout-auth',
  CodeConfirmation = 'code-confirmation',
  EmailConfirmation = 'email-confirmation',
}
